export default __webpack_public_path__ + "static/media/webcam9.abb39325.jfif";